/* LK-CONGRATS: cart drawer celebration + "50% OFF locked in" 10-minute clock + real savings on the lines.
   Self-contained: injects its own CSS and markup, hooks the existing #lk-drawer open/close and #lk-ditems renders.
   Nothing here adds to cart or changes prices; it only shows the compare-at the page already carries. */
(function(){
  if (window.__lkCG) return; window.__lkCG = true;
  var HOLD = 600;                       // seconds the offer is shown as held
  var KEY  = 'lk_cg_start';             // sessionStorage: when the clock started (first drawer open this session)
  var CSS = ''
  + '.lk-cg{padding:9px 18px 0;background:#fff;position:relative}'
  + '.lk-cg-row{display:flex;align-items:center;gap:8px;min-height:26px}'
  + '.lk-cg-tag{display:inline-block;background:#B2295A;color:#fff;font-weight:800;font-size:12px;letter-spacing:.04em;padding:4px 8px;border-radius:7px;line-height:1;white-space:nowrap}'
  + '.lk-cg-txt{font-size:12.5px;color:#4a4a4a;font-weight:600;flex:1 1 auto;line-height:1.2}'
  + '.lk-cg-txt b{color:#881848;font-weight:800}'
  + '.lk-cg-clock{display:inline-flex;align-items:center;gap:4px;font-weight:800;font-size:15px;color:#881848;font-variant-numeric:tabular-nums;letter-spacing:.02em;white-space:nowrap}'
  + '.lk-cg-clock svg{width:14px;height:14px;display:block}'
  + '.lk-cg-bar{height:3px;background:#f3dde5;border-radius:2px;margin:8px 0 0;overflow:hidden}'
  + '.lk-cg-bar i{display:block;height:100%;width:100%;background:linear-gradient(90deg,#B2295A,#e26a8f);border-radius:2px;transform-origin:left center;transition:transform 1s linear}'
  + '.lk-cg.lk-cg-last .lk-cg-clock{animation:lkcgPulse 1s ease-in-out infinite}'
  + '.lk-cg.lk-cg-done .lk-cg-clock,.lk-cg.lk-cg-done .lk-cg-bar{display:none}'
  + '.lk-cg.lk-cg-done{padding-bottom:9px}'
  + '.lk-cg-was{color:#9a8a90;font-weight:400;font-size:12px;text-decoration:line-through;display:block;text-align:right;line-height:1.1}'
  + '.lk-cg-save{display:flex;justify-content:space-between;font-size:12.5px;color:#1a7a45;font-weight:600;margin:-6px 0 8px}'
  + '.lk-cg-save b{font-weight:800}'
  + '.lk-cg-conf{position:absolute;left:0;right:0;top:0;height:280px;pointer-events:none;overflow:hidden;z-index:5}'
  + '.lk-cg-conf i{position:absolute;top:-14px;left:var(--x);width:var(--s);height:var(--s);background:var(--c);border-radius:var(--rd);opacity:0;animation:lkcgFall var(--d) cubic-bezier(.2,.6,.4,1) var(--dl) forwards}'
  + '@keyframes lkcgFall{0%{transform:translate3d(0,0,0) rotate(0);opacity:1}80%{opacity:1}100%{transform:translate3d(var(--dx),290px,0) rotate(var(--r));opacity:0}}'
  + '@keyframes lkcgPop{0%{transform:scale(.6)}60%{transform:scale(1.12)}100%{transform:scale(1)}}'
  + '.lk-cg-pop .lk-cg-tag{animation:lkcgPop .55s cubic-bezier(.2,.8,.3,1.2) both}'
  + '@keyframes lkcgPulse{0%,100%{opacity:1}50%{opacity:.55}}'
  + '@media (prefers-reduced-motion:reduce){.lk-cg-conf{display:none}.lk-cg-pop .lk-cg-tag,.lk-cg.lk-cg-last .lk-cg-clock{animation:none}}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  function $(id){ return document.getElementById(id); }
  var drawer, band, clock, fill, txt, iv = null, decorating = false;

  function build(){
    drawer = $('lk-drawer'); if (!drawer || $('lk-cg')) return;
    var head = drawer.querySelector('.lk-dhead'); if (!head) return;
    band = document.createElement('div'); band.className = 'lk-cg'; band.id = 'lk-cg';
    band.innerHTML = '<div class="lk-cg-row"><span class="lk-cg-tag">50% OFF</span>'
      + '<span class="lk-cg-txt" id="lk-cg-txt">locked in for you</span>'
      + '<span class="lk-cg-clock" id="lk-cg-clock" aria-live="off"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span id="lk-cg-num">10:00</span></span></div>'
      + '<div class="lk-cg-bar"><i id="lk-cg-fill"></i></div>';
    head.insertAdjacentElement('afterend', band);
    clock = $('lk-cg-num'); fill = $('lk-cg-fill'); txt = $('lk-cg-txt');
    var items = $('lk-ditems');
    if (items) new MutationObserver(function(){ decorate(); }).observe(items, {childList:true});
    decorate();
  }

  function startedAt(){
    var t = 0; try { t = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch(e) {}
    if (!t) { t = Date.now(); try { sessionStorage.setItem(KEY, String(t)); } catch(e) {} }
    return t;
  }
  function tick(){
    var left = HOLD - Math.floor((Date.now() - startedAt()) / 1000);
    if (left <= 0) {
      left = 0; band.classList.add('lk-cg-done'); band.classList.remove('lk-cg-last');
      txt.innerHTML = 'applied to your order';
      if (iv) { clearInterval(iv); iv = null; }
      return;
    }
    var m = Math.floor(left / 60), s = left % 60;
    clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    fill.style.transform = 'scaleX(' + (left / HOLD) + ')';
    band.classList.toggle('lk-cg-last', left <= 60);
  }
  function run(){
    tick(); if (!iv) iv = setInterval(tick, 1000);
  }

  function confetti(){
    var once = false; try { once = !!sessionStorage.getItem(KEY + '_conf'); } catch(e) {}
    if (once) return;
    try { sessionStorage.setItem(KEY + '_conf', '1'); } catch(e) {}
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    band.classList.add('lk-cg-pop');
    var box = document.createElement('div'); box.className = 'lk-cg-conf';
    var cols = ['#B2295A','#e26a8f','#f5c3cf','#f4c542','#7bc8a4','#ffffff'];
    var html = '';
    for (var i = 0; i < 42; i++) {
      var x = Math.random() * 100, s = 6 + Math.random() * 6, d = (1.3 + Math.random() * 0.9).toFixed(2),
          dl = (Math.random() * 0.35).toFixed(2), dx = ((Math.random() - 0.5) * 120).toFixed(0), r = (Math.random() * 720 - 360).toFixed(0),
          c = cols[i % cols.length], rd = (i % 3 === 0) ? '50%' : '2px';
      html += '<i style="--x:' + x.toFixed(1) + '%;--s:' + s.toFixed(1) + 'px;--d:' + d + 's;--dl:' + dl + 's;--dx:' + dx + 'px;--r:' + r + 'deg;--c:' + c + ';--rd:' + rd + '"></i>';
    }
    box.innerHTML = html;
    drawer.appendChild(box);
    setTimeout(function(){ if (box.parentNode) box.parentNode.removeChild(box); band.classList.remove('lk-cg-pop'); }, 2600);
  }

  /* Real savings. Compare-at prices come from Shopify's own product JSON (cached per handle),
     so every line is covered: kits, glue jars, remover, and anything added later. */
  var PCACHE = {};
  function product(handle){
    if (PCACHE[handle]) return PCACHE[handle];
    PCACHE[handle] = fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        var m = {};
        if (p && p.variants) for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i]; if (v.compare_at_price) m[String(v.id)] = v.compare_at_price;
        }
        return m;
      }).catch(function(){ return {}; });
    return PCACHE[handle];
  }
  function money(sample, cents){
    var pre = (sample.match(/^[^\d]*/) || [''])[0], post = (sample.match(/[^\d.,]*$/) || [''])[0];
    var dec = /,\d{2}$/.test(sample.replace(/[^\d.,]/g,'')) ? ',' : '.';
    var v = (cents / 100).toFixed(2); if (dec === ',') v = v.replace('.', ',');
    return pre + v + post;
  }
  function decorate(){
    if (decorating) return; decorating = true;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var items = cart.items || [], handles = [];
      for (var i = 0; i < items.length; i++) if (items[i].handle && handles.indexOf(items[i].handle) < 0) handles.push(items[i].handle);
      return Promise.all(handles.map(product)).then(function(maps){
        var cmpBy = {};
        for (var k = 0; k < handles.length; k++) for (var vid in maps[k]) cmpBy[vid] = maps[k][vid];
        return {items: items, cmpBy: cmpBy};
      });
    }).then(function(d){
      var byKey = {}; for (var i = 0; i < d.items.length; i++) byKey[d.items[i].key] = d.items[i];
      var rows = document.querySelectorAll('#lk-ditems .lk-ditem'), save = 0, sample = null;
      for (var j = 0; j < rows.length; j++) {
        var row = rows[j], pr = row.querySelector('.lk-diprice'); if (!pr) continue;
        var old = pr.querySelector('.lk-cg-was'); if (old) old.parentNode.removeChild(old);
        var btn = row.querySelector('[onclick*="lkQty"]'); if (!btn) continue;
        var key = (btn.getAttribute('onclick').match(/lkQty\('([^']+)'/) || [])[1] || '';
        var it = byKey[key]; if (!it) continue;
        var txtP = (pr.textContent || '').trim();
        var cmp = (d.cmpBy[String(it.variant_id)] || 0) * it.quantity, paid = it.final_line_price;
        sample = sample || txtP;
        /* A gifted line already prints its own strike-through and reads FREE: count the saving, add no second one. */
        if (pr.querySelector('s')) { if (cmp > paid) save += cmp - paid; continue; }
        if (!cmp || cmp <= paid) continue;
        save += cmp - paid;
        var e = document.createElement('s'); e.className = 'lk-cg-was'; e.textContent = money(txtP || '$0.00', cmp);
        pr.insertBefore(e, pr.firstChild);
      }
      var sub = document.querySelector('#lk-drawer .lk-dsub'), line = $('lk-cg-save');
      if (sub && save > 0) {
        if (!line) { line = document.createElement('div'); line.className = 'lk-cg-save'; line.id = 'lk-cg-save'; sub.insertAdjacentElement('afterend', line); }
        line.innerHTML = '<span>You save today</span><b>' + money(sample || '$0.00', save) + '</b>';
      } else if (line) { line.parentNode.removeChild(line); }
      decorating = false;
    }).catch(function(){ decorating = false; });
  }

  function init(){
    build(); if (!band) return;
    var obs = new MutationObserver(function(){
      if (drawer.classList.contains('open')) { run(); confetti(); }
    });
    obs.observe(drawer, {attributes:true, attributeFilter:['class']});
    if (drawer.classList.contains('open')) { run(); confetti(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
